export interface SupportedUrlParams {
  defaultOcclusion?: number;
  defaultRoughness?: number;
  defaultMetallic?: number;
}

export const getUrlParams = (): SupportedUrlParams => {
  const urlParams = new URLSearchParams(window.location.search);
  const params: SupportedUrlParams = {};
  urlParams.forEach((value, key) => ((params as any)[key] = value));
  return params;
};
